// src/pages/CustomerManagement/AddCustomer.tsx

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styles from "./AddCustomer.module.scss";
import api from "../../api/client";

const AddCustomer: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [ssn, setSSN] = useState("");
  const [spouseId, setSpouseId] = useState("");
  // const [taxdomeId, setTaxdomeId] = useState("");
  // const [applyDiscount, setApplyDiscount] = useState(false);

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    const newUser = {
      full_name: fullName,
      email: email,
      ssn: ssn,
      spouse_id: spouseId || null,
      // taxdome_id: taxdomeId || null,
      // apply_discount: applyDiscount,
    };

    try {
      await api.post("/add_customer", newUser);
      navigate("/customer_management");
    } catch (error) {
      console.error("Failed to add customer:", error);
      // console.error("Method not allowed:", error);
      alert(t("customerManagement.addFail"));
      // alert("Method not allowed");
    }
  };

  const handleBack = () => {
    navigate("/customer_management");
  };

  return (
    <div className={styles.addCustomerContainer}>
      <div className={styles.addCustomerBox}>
        <h1>{t("customerManagement.addUserTitle")}</h1>
        <form onSubmit={handleSave} className={styles.addCustomerForm}>
          <div className={styles.formGroup}>
            <label>{t("customerManagement.fullName")}</label>
            <input
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              type="text"
            />
          </div>
          <div className={styles.formGroup}>
            <label>{t("customerManagement.email")}</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              type="email"
            />
          </div>
          <div className={styles.formGroup}>
            <label>{t("customerManagement.ssn")} ***Format: xxx-xx-xxxx</label>
            <input
              value={ssn}
              onChange={(e) => setSSN(e.target.value)}
              type="text"
            />
          </div>
          <div className={styles.formGroup}>
            <label>{t("customerManagement.spouseId")}</label>
            <input
              value={spouseId}
              onChange={(e) => setSpouseId(e.target.value)}
              type="text"
            />
          </div>
          {/* <div className={styles.formGroup}>
            <label>{t("customerManagement.taxdomeID")}</label>
            <input
              value={taxdomeId}
              onChange={(e) => setTaxdomeId(e.target.value)}
              type="text"
            />
          </div>
          <div className={styles.formGroup}>
            <label>{t("customerManagement.applyDiscount")}</label>
            <input
              type="checkbox"
              checked={applyDiscount}
              onChange={(e) => setApplyDiscount(e.target.checked)}
            />
          </div> */}

          <div className={styles.buttons}>
            <button type="button" onClick={handleBack}>
              {t("general.back")}
            </button>
            <button type="submit">{t("general.save")}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCustomer;
